import { useState } from "react";
import { useRef } from "react";
import emailjs from "@emailjs/browser";
import contatti from "../../assets/contatti.jpg";
import { Helmet } from "react-helmet";

export const Contatti = () => {
    const form = useRef();
    const [emailSent, setEmailSent] = useState(false);

    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm("service_kmo9gsn", "template_h08vzot", form.current, "HCBPHfQvoRj81pUl-").then(
            (result) => {
                if (result.status == 200) {
                    document.getElementById("richiesta").value = "";
                    document.getElementById("user_name").value = "";
                    document.getElementById("mail").value = "";
                    setEmailSent(true);
                    setTimeout(() => {
                        setEmailSent(false);
                    }, 2000);
                }
            },
            (error) => {
                console.log(error.text);
            }
        );
    };

    return (
        <>
            <title>
                <Helmet> Contatti </Helmet>
            </title>

            <section id="contatti" className="bgCream">
                <div className="container pb-5 pt-4 textBlue">
                    <div className="row">
                        <h1 className="fs-1 text-center mb-5">Contatti</h1>

                        <div className="mt-3 fs-5 col-12 col-md-6 d-flex flex-column justify-content-center">
                            <p>
                                Mail:{" "}
                                <a
                                    target="_blank"
                                    className="textBlue underline-none"
                                    href=" mailto: doulacri@gmail.com"
                                >
                                    doulacri@gmail.com
                                </a>
                            </p>

                            <p>
                                Instagram:{" "}
                                <a
                                    target="_blank"
                                    className="textBlue underline-none"
                                    href="https://www.instagram.com/custodiamoci_doula_cristina/"
                                >
                                    @custodiamoci_doula_cristina
                                </a>
                            </p>

                            <p>
                                Facebook:{" "}
                                <a
                                    target="_blank"
                                    className="textBlue underline-none"
                                    href="https://www.facebook.com/criscustodiamoci/"
                                >
                                    Custodiamoci - Doula Cristina
                                </a>
                            </p>

                            <p>Sono attiva online e in tutta la provincia di Pavia! </p>
                        </div>
                        {window.screen.width > 500 && (
                            <div className="col-12 col-md-6 d-flex justify-content-center">
                                <img className="immagine-contatti" src={contatti} alt="" />
                            </div>
                        )}
                        <div className="mt-5">
                            <h2 className="text-center mb-4">
                                Compila il form sottostante per richiedere informazioni
                            </h2>
                        </div>
                        <h5 className="underline font-bold" style={{ color: emailSent ? "#0088a3" : "transparent" }}>
                            Email Inviata con successo!
                        </h5>
                        <form ref={form} onSubmit={sendEmail}>
                            <div className="d-flex w-full justify-content-between gap-5 my-4">
                                <div className="w-75">
                                    <label>Nome</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="user_name"
                                        placeholder="Inserisci nome"
                                    />
                                </div>
                                <div className="w-75">
                                    <label>Email</label>
                                    <input
                                        type="email"
                                        name="user_email"
                                        className="form-control"
                                        id="mail"
                                        placeholder="Inserisci email"
                                    />
                                </div>
                            </div>
                            <div>
                                <label>Messaggio</label>
                                <textarea
                                    placeholder="Inserisci Messaggio"
                                    className="form-control"
                                    id="richiesta"
                                    name="message"
                                    rows="5"
                                ></textarea>
                            </div>

                            <input type="submit" value="Send" className="btn btn-success mt-3" />
                        </form>
                    </div>
                </div>
            </section>
        </>
    );
};
